import type { ShouldRevalidateFunction } from "react-router-dom";
import { isAuthContextCacheValid } from "~/utils/auth/authContextCache";

/** Skip MainLayout loader on child route navigations when auth context is cached. */
export const mainLayoutShouldRevalidate: ShouldRevalidateFunction = ({
  defaultShouldRevalidate,
  formMethod,
}) => {
  if (formMethod && formMethod !== "GET") {
    return defaultShouldRevalidate;
  }

  if (isAuthContextCacheValid()) {
    return false;
  }

  return defaultShouldRevalidate;
};
